<template>
  <el-dialog
    :title="isImportContract ? '导入总包合同' :'导入其他'"
    :visible.sync="isShow"
    :before-close="hideAddDialog"
    width="30%"
    :close-on-click-modal="false"
  >
    <el-upload
      ref="upload"
      class="upload-demo"
      :data="uploadParam"
      :action="uploadUrl"
      :on-error="uploadFaildAction"
      :on-success="upLoadSuccessAction"
      :auto-upload="false"
      drag
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
    </el-upload>
    <div slot="footer" class="dialog-footer">
      <el-button @click="hideAddDialog">取 消</el-button>
      <el-button type="primary" @click="submitUpload">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  exportContractExcel
} from "../../../services/allContractServices";
export default {
  name: "uploadDialog",
  props: {
    isShow: {
      default: false,
      type: Boolean
    },
    isImportContract: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      uploadUrl: "",
      uploadParam:{userCode:sessionStorage.getItem("userCode")}
    };
  },
  watch: {
    isShow(newValue) {
      if (!newValue) return
      this.uploadUrl = this.getUploadUrl();
      console.log(this.uploadUrl);
    }
  },
  methods: {
    hideAddDialog() {
      this.$emit("close");
      this.$refs.upload.clearFiles();
    },
    getUploadUrl() {
      return  exportContractExcel();
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    upLoadSuccessAction(response, file, fileList) {
      if (response.resultCode == 0) {
        this.$message.success(response.msg);
      } else {
        this.$message.error(response.msg);
      }
      this.hideAddDialog();
    },
    uploadFaildAction(err, file, fileList) {
      this.$message.error(err.msg);
    }
  }
};
</script>

<style>
</style>